// extracted by mini-css-extract-plugin
export default {"on":"Nav_on__kUq3w","off":"Nav_off__luESm","inpt":"Nav_inpt__XMERI","header":"Nav_header__N9nSZ","container":"Nav_container__omOm2","btn":"Nav_btn__tyjCg"};